import React from 'react';
import { CarouselProducts } from './index';

import { useAppContext } from 'src/components/app-context';

import type { CarouselTypeEnum } from './types';
import type {
  Maybe,
  Model,
  CarouselProduct as CarouselProductType,
  RecommendedProduct,
} from 'src/types';

type Props = {
  recommendations?: Maybe<Model[]>;
};

export const OtherAlsoVisitedCarousel: React.FC<Props> = ({
  recommendations,
}) => {
  const { t } = useAppContext();

  if (!recommendations?.length) return null;

  const recommendedProducts = recommendations!
    .flatMap(rec =>
      rec.recommendations!.map(p => p.product as RecommendedProduct)
    )
    .filter(isTruthy => isTruthy)
    .map(
      (p: RecommendedProduct) =>
        ({
          aggregatedRating: p.aggregatedRating,
          category: p.category,
          classicFullPath: p.uri,
          id: p.id,
          imageUrl: p.media?.first,
          name: p.name,
          // @ts-expect-error Should get fixed (in other MR) with the new resolver not to also include the domain etc.
          pathName: p.pathName,
          price: p.price?.regular,
          type: recommendations[0].model,
          url: p.webUri,
          userReviewSummary: p.userReviews,
        } as CarouselProductType & { type: CarouselTypeEnum })
    );

  if (!recommendedProducts.length) return null;

  const carouselType = recommendations[0].model as CarouselTypeEnum;

  return (
    <CarouselProducts
      products={recommendedProducts}
      carouselType={carouselType}
      title={t('product', 'recommendations.others-visited')}
    />
  );
};
